import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Button,
  Alert,
  CircularProgress,
} from "@mui/material";
import { LOT_STATUS_TYPES, changeLotStatusType } from "../api/lotStatusService";

const ChangeLotStatusModal = ({
  open,
  onClose,
  lotId,
  currentType,
  onSuccess,
}) => {
  const [lotStatusType, setLotStatusType] = useState(currentType || "");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setLotStatusType(currentType || "");
      setMessage(null);
      setError(null);
    }
  }, [open, currentType]);

  const handleSubmit = async () => {
    if (!lotId || !lotStatusType) return;
    setSubmitting(true);
    setError(null);
    try {
      const msg = await changeLotStatusType({ id: lotId, lotStatusType });
      setMessage(msg);
      onSuccess?.();
    } catch (e) {
      setError(e?.message || "Ошибка при смене статуса");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Изменить статус лота</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
      >
        <TextField label="Id" value={lotId || ""} disabled size="small" />

        <TextField
          select
          label="Новый статус"
          value={lotStatusType}
          onChange={(e) => setLotStatusType(e.target.value)}
          size="small"
        >
          {LOT_STATUS_TYPES.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </TextField>

        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Закрыть</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={submitting || !lotStatusType}
        >
          {submitting ? <CircularProgress size={20} /> : "Сохранить"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeLotStatusModal;
